module.exports = __webpack_public_path__ + "assets/facebook-footer-a4ff48.svg";